import { Form, Button, Modal } from "react-bootstrap";
import { FiPlus } from "react-icons/fi";
import { groupAndProjectServices } from "../../../APIServices/WorkBridge/TeamManagement/groupAndProjectServices";
import { useState } from "react";

const AddGroup = ({ Show, Hide, Title, isDark, getGroupAndProjectList }) => {
  const [loader, setLoader] = useState(false)
  const [groupName, setGroupName] = useState("")
  const [groupDescription, setGroupDescription] = useState("")
  const [groupType, setGroupType] = useState("public")

  const addNewGroupAndProject = async () => {
    let userData = {}
    setLoader(true)
    userData.name = groupName
    userData.description = groupDescription
    userData.type = groupType
    userData.category = "group"
    let data = await groupAndProjectServices.addNewGroupAndProject(userData)
    if (data?.statusCode === 200) {
      setLoader(false)
      setGroupName("")
      setGroupDescription("")
      setGroupType("")
      getGroupAndProjectList()
      Hide()
    }
  }
  return (
    <Modal show={Show} onHide={Hide} size="md">
      <Modal.Header
        closeButton
        className={`${isDark ? "bg-dark text-light" : "bg-light"} p-3 border-bottom`}
      >
        <Modal.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className={`rounded-bottom ${isDark ? "bg-dark" : "bg-white"}`}
      >
        <Form.Group className="mb-2">
          <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
            Group Name
          </Form.Label>
          <Form.Control
            type="text"
            onChange={(e) => setGroupName(e.target.value)}
            value={groupName}
            className="interactive-input"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="Enter Group Name"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
            Group Description
          </Form.Label>
          <Form.Control
            as="textarea"
            row={3}
            onChange={(e) => setGroupDescription(e.target.value)}
            value={groupDescription}
            className="interactive-input"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="Enter Group Description"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
            Group Type
          </Form.Label>
          <Form.Select
            onChange={(e) => setGroupType(e.target.value)}
            value={groupType}
            style={{ fontSize: 12 }}>
            <option value={"public"}>Public</option>
            <option value={`private`}>Private</option>
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <div className="hstack justify-content-end">
          <Button
            variant="outline-primary"
            style={{ fontSize: 13 }}
            title={Title}
            onClick={addNewGroupAndProject}
            disabled={!groupName || !groupDescription || !groupType || loader}
            className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
          >
            <FiPlus />
            Add New
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddGroup;
